awardCalculation.classy.controller({
    name: 'AllowedSavingsController',
    inject: ['$scope', '$http', 'RestService', 'ApplicationService', 'CalculationService', 'ModelService', 'BinFactory', 
            'DateService', 'ResetService', 'FamilyThresholdsService'],
    init: function()
    {
        this.$.isArchive = this.BinFactory.isArchive();
        this.$.DateService = this.DateService;
        this.$.ResetService = this.ResetService;
    },
    allowedSavingsPut: function(scope, instance, form)
    {
        instance.options.factor = .3;
        var self = this;
        var putDataThresh = {};
        putDataThresh.Thresh_Savings_Allowed_Percent = this.ApplicationService.getFamilyData().thresholds.Thresh_Savings_Allowed_Percent;
        putDataThresh.Thresh_Savings_Allowed_Cap = this.ApplicationService.getFamilyData().thresholds.Thresh_Savings_Allowed_Cap;
        putDataThresh.familyID = this.ApplicationService.getFamilyData().thresholds.familyID
        return this.FamilyThresholdsService.put(putDataThresh).success(function(data, status, headers, config) {
                    self.CalculationService.reCalc();
                    instance.options.callMe(data, status, headers, config, instance);
            });
    }
});
